import React, { FC } from 'react';
import styled from 'styled-components';
import { DEVICE_PLACEHOLDERS } from 'config';
import { fontSemibold } from '../../../themes';

import { AppType } from '../../../constants';
import App from '../../../models/app';
import { BannerContainer } from './BannerContainer';
import { TileContainer, TileImage } from './TileImage';
import Typography from '../Typography';

const DEVICES: any = DEVICE_PLACEHOLDERS;
const DEFAULT_TILE_WIDTH = 65;
const DEFAULT_TILE_WIDTH_BEZELS = 72;

const BannerDiv = styled.div<any>`
  width: 75px;
  flex-shrink: 0;
  ${({ premiumTileIcon }) => premiumTileIcon ?
    `background: url(${premiumTileIcon}) center center / contain no-repeat;` :
    ''
  }
  ${({ flex }) => flex ?
    `flex: ${flex};` :
    ''
  }
`;

const Container = styled.div<any>`
  display: flex;
`;

const CenterContent = styled.div`
  flex-grow: 1;
  min-width: 0px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Name = styled.div`
  font-family: ${fontSemibold};
  padding: 3px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
`;

const SubNameContainer = styled.div`
  display: flex;
`;

const SubName = styled.div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;

  color: #707C83;
`;

interface ModalImageContainerProps {
  app: App;
  deviceName?: string;
}

export const ModalImageContainer: FC<ModalImageContainerProps> = ({
  app,
  deviceName,
}) => {
  const isTile = app.type.toLowerCase() === AppType.TILE.toLowerCase();
  const screenshot = (isTile || !app.icon) ? app.banners?.[0] : app.icon;
  const premiumTileIcon = isTile && app.isPremium && deviceName ?
    DEVICES[deviceName.toLowerCase()]?.premiumTileIcon : null;

  return isTile ?
    (
      <TileContainer
        premiumTileIcon={premiumTileIcon}
        size={screenshot}
        tileBezelWidth={DEFAULT_TILE_WIDTH_BEZELS}
      >
        <TileImage
          image={screenshot}
          name={app.name}
          tileWidth={DEFAULT_TILE_WIDTH}
        />
      </TileContainer>
    ) : (
      <BannerDiv>
        <BannerContainer
          containerAttr={{
            width: screenshot.width,
            height: screenshot.height,
          } as any}
          imageAttr={{
            src: screenshot.uri,
            alt: name,
          }}
        />
      </BannerDiv>
    );
};

interface ModalImageContainerWithTextProps {
  app: App;
  text: string;
  subtext: string;
  deviceName?: string;
}

export const ModalImageContainerWithText: FC<ModalImageContainerWithTextProps> = ({
  app,
  text,
  subtext,
  deviceName,
}) => (
  <Container>
    <ModalImageContainer
      app={app}
      deviceName={deviceName}
    />
    <CenterContent>
      <Typography
        variant="bodyLargeEmphasized"
        color="var(--sys-color--on-surface)"
        style={{
          padding: '3px 0',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          textAlign: 'left',
        }}
      >
        {text}
      </Typography>
      <SubNameContainer>
        {subtext && (
          <Typography
            variant="bodyMedium"
            color="var(--sys-color--on-surface-variant)"
            style={{ textAlign: 'left' }}
          >
            {subtext}
          </Typography>
        )}
      </SubNameContainer>
    </CenterContent>
  </Container>
);
